import script from "./Categories.vue?vue&type=script&lang=ts&setup=true"
export * from "./Categories.vue?vue&type=script&lang=ts&setup=true"

import "./Categories.vue?vue&type=style&index=0&id=58dfb2a9&scoped=true&lang=css"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58dfb2a9"]])

export default __exports__